import React, { useState } from "react";
import Button from "../button/Button";

const ImagePopUpModal = ({ imageUrl, customClass, alt }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [isImageValid, setIsImageValid] = useState(true); // Track image validity

  // Check if the image URL is valid
  const checkImageValidity = (url) => {
    const img = new Image();
    img.src = url;
    img.onload = () => setIsImageValid(true);
    img.onerror = () => setIsImageValid(false);
  };

  // Open modal only if the image is valid
  const openModal = (image) => {
    checkImageValidity(image);
    if (isImageValid) {
      setSelectedImage(image);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage("");
    setIsImageValid(true); // Reset validity for next check
  };

  const downloadImage = async (url) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      if (!response.ok) {
        throw new Error("Image download failed");
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "image.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the image:", error);
    }
  };

  return (
    <div>
      {/* Image or Fallback UI */}
      {imageUrl ? (
        isImageValid ? (
          <img
            src={imageUrl}
            alt={alt}
            className={`${customClass} cursor-pointer`} // Custom class applied here
            onClick={() => openModal(imageUrl)}
            onError={() => setIsImageValid(false)} // Handle image load error
          />
        ) : (
          <div
            className={`${customClass} flex text-center items-center justify-center bg-gray-200 text-gray-500 rounded`}
            style={{ width: "100px", height: "100px" }} // Customize size as needed
          >
            <p>Invalid or missing image</p>
          </div>
        )
      ) : null}

      {/* Modal */}
      {isModalOpen && isImageValid && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 relative">
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-black text-2xl font-bold"
              onClick={closeModal}
            >
              ×
            </button>

            {/* Image */}
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-full max-h-96 mb-4 rounded"
              onError={() => {
                setIsImageValid(false);
                setIsModalOpen(false); // Close modal if image fails to load
              }}
            />

            {/* Download Button */}
            <div className="flex justify-center">
              <Button
                onClick={() => downloadImage(selectedImage)}
                text="Download"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImagePopUpModal;
